import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import PlaceholderBlock from './PlaceholderBlock.component'
import SuggestionsIcon from 'components/Common/SvgIcons/SuggestionsIcon'
import { toolsCategory } from 'components/Tools/data'
import history from 'utils/history'
import { Tool } from '__generated__/api-types-and-hooks'
import { ROLES } from 'config'

interface IToolPlaceholderProps {
  toolCategoryValue: string
  toolDescription: string
  tenantId: string
  role: string
  toolsList: Tool[]
}
const ToolPlaceholder: FC<IToolPlaceholderProps> = ({
  toolCategoryValue,
  toolsList,
  toolDescription,
  role,
  tenantId,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <p className="pt-4 pb-16 text-grey-dark font-normal text-xl leading-7">{toolDescription}</p>
      {toolCategoryValue === toolsCategory.toolKit.value &&
      role === ROLES.BUSINESS_OWNER &&
      toolsList.length === 0 ? (
        <PlaceholderBlock
          Icon={SuggestionsIcon}
          Paragraph={`
        <p class="!font-medium !text-primary-text">
          ${t('tools.browseCategories')}
        </p>
        <p class="!font-medium !text-primary-text pt-5 pb-3">
          ${t('tools.completeAssessments')}
        </p>`}
          buttonLabel={t('tools.takeAssessment')}
          handleClick={() => history.push(`/${role}/${tenantId}/playbooks`)}
        />
      ) : toolsList.length === 0 ? (
        <PlaceholderBlock
          Icon={SuggestionsIcon}
          Paragraph={` <p class="!font-medium !text-primary-text">
         ${t('tools.noToolFound')}
        </p>`}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default ToolPlaceholder
